import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { X } from "react-feather";
import styled from "styled-components/macro";

import client from "../../api/client/SdsWebApiClient";
import { getSessionId } from "../../store/sagas/selectors";

const SaveImageCard = styled.div`
    position: absolute;
    left: calc(50% - 150px);
    top: calc(50% - 110px);
    width: 300px;
    height: 140px;
    box-sizing: border-box;
    text-align: center;
    color: black;
    padding: 40px 10px 10px 10px;
    background: rgba(255, 255, 255, 1);
    z-index: 6;
`;

const CloseButton = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 22px;
    height: 22px;
    text-align: center;
    margin: 10px;
    cursor: pointer;
    &:hover {
        color: ${props => props.theme.textColorSecondary};
    }
`;

const SaveButton = styled.a<SaveButtonInterface>`
    position: absolute;
    display: inline-block;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 118px;
    padding: 10px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    background: ${({ disabled, theme }) => (disabled ? "darkgrey" : theme.buttonNext.backgroundColor)};
    text-decoration: none;
    &:hover {
        background: ${({ disabled, theme }) => (disabled ? "darkgrey" : theme.buttonNext.backgroundColor)};
    }
    color: ${props => (props.disabled ? "lightgrey" : "white")};
`;

interface SaveButtonInterface {
    disabled: boolean;
}

export const SaveImageDialog = ({ onClose }: { onClose: (event: any) => void }) => {
    const sessionId = useSelector(getSessionId);
    const [loading, setLoading] = useState(true);
    const [zipUrl, setZipUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!sessionId) return;
        client.getMediaKitGet(sessionId).then(
            url => {
                setLoading(false);
                setZipUrl(url);
            },
            () => {
                setLoading(false);
            }
        );
    }, [sessionId]);

    const renderText = () => {
        if (loading) return "Generating...";
        if (zipUrl) return "Image is ready";
        return "Error";
    };

    return (
        <SaveImageCard>
            <CloseButton onClick={onClose}>
                <X size={22} color="#000" />
            </CloseButton>
            {renderText()}
            <SaveButton disabled={loading || !zipUrl} href={zipUrl}>
                Save
            </SaveButton>
        </SaveImageCard>
    );
};
